import { parser } from "../../erd-editor-schema/dist/v3/parser/index.js";
import { toJson } from "../../erd-editor-schema/dist/parser.js";
import { convertToSchema } from "./convert.js";
import { parseAMLModel } from "./parser.js";
//#region src/utils/schema-aml-parser/index.ts
var EMPTY_MODEL = {
	entities: [],
	relations: [],
	types: {},
	skipped: []
};
function schemaAMLParserToSchemaJson(aml, ctx, prepare) {
	const result = parseAMLModel(aml);
	const model = result.ok ? result.model : EMPTY_MODEL;
	const schema = parser({});
	const { settings } = prepare ? prepare(schema) : schema;
	const converted = convertToSchema(model, ctx, settings.database);
	converted.settings = settings;
	return toJson(converted);
}
//#endregion
export { schemaAMLParserToSchemaJson };
